import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { waterFillingMachines } from '../../mock/mockData';

const WaterFilling60BPM = () => {
  const productData = waterFillingMachines.find(p => p.id === 'wfm-60');
  return <ProductPageTemplate productData={productData} />;
};

export default WaterFilling60BPM;